import {formsStore} from '../../../stores/Form';
import {fieldValue} from '../../../stores/Form/Field';

export async function setMultiSelectValues(values: fieldValue[]) {
    const activeForm = formsStore.getActiveForm();

    if (values.length > 1 && activeForm) {
        const activeScreen = formsStore.getScreenBySession(activeForm.session);
        const {currentColumnId, currentRow: currentRowIndex} = activeForm;
        let activeRow = currentRowIndex;

        for (const fieldValue of values) {
            const newRecord = activeForm.records[activeRow];
            const field = newRecord.getField(currentColumnId);
            field.setCurrentValue(fieldValue);

            const isUpdateSucceed = await activeScreen.fieldUpdate();
            if (!isUpdateSucceed) {
                break;
            }
            const isSaveSucceed = await activeScreen.saveRecord();
            if (!isSaveSucceed) {
                break;
            }
            activeRow = activeRow + 1;
            if (!activeForm.records[activeRow]) {
                activeForm.insertEmptyRecord(currentRowIndex);
            }
            activeForm.setCurrentRow(activeRow);
        }
    }
}
